/**
 * Msg 578 · Emergency "force refresh" magic route.
 *
 * Advisor hits `/reset-cache` in the URL bar → this component
 * unregisters every service worker, clears every Cache Storage
 * bucket, wipes localStorage + sessionStorage, and redirects to
 * `/atlas/topics?_cb=<timestamp>` with a cache-busting query so
 * the browser can never serve a stale bundle again.
 */
import React, { useEffect } from "react";

export default function ResetCachePage() {
  useEffect(() => {
    (async () => {
      try {
        if ("serviceWorker" in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations();
          for (const r of regs) { try { await r.unregister(); } catch { /* noop */ } }
        }
      } catch { /* noop */ }
      try {
        if ("caches" in window) {
          const keys = await caches.keys();
          for (const k of keys) { try { await caches.delete(k); } catch { /* noop */ } }
        }
      } catch { /* noop */ }
      try { localStorage.clear(); } catch { /* noop */ }
      try { sessionStorage.clear(); } catch { /* noop */ }
      // Redirect to the topics tab with a cache-bust query so no
      // intermediate proxy layer can serve stale HTML either.
      window.location.href = `/atlas/topics?_cb=${Date.now()}`;
    })();
  }, []);
  return (
    <div style={{ padding: 40, fontSize: 18, fontFamily: "system-ui, sans-serif",
                    color: "#1e2b4a" }}
         data-testid="reset-cache-page">
      Clearing cache and reloading…
    </div>
  );
}
